import { type UserProfile, getCurrentUserProfileFn, saveCurrentUserProfileFn } from "../common/openapi";

import type { QueryCacheInteractions, UseFullQueryOptions, UseMutationOptions } from "./react-query";

const QUERY_USER_PROFILE_QUERY_KEY = ["user", "profile"] as const;

export const queryUserProfile = {
	queryKey: QUERY_USER_PROFILE_QUERY_KEY,
	queryFn: () => getCurrentUserProfileFn({}),

	// TODO https://stackstate.atlassian.net/browse/OBSFE-120
	// it is ugly to have the query key like that, but it is the only way to make it work
	getData: (queryClient) => queryClient.getQueryData([{}, ...QUERY_USER_PROFILE_QUERY_KEY]),
	setData: (queryClient, data) => queryClient.setQueryData([{}, ...QUERY_USER_PROFILE_QUERY_KEY], data),
	removeData: (queryClient) => queryClient.removeQueries([{}, ...QUERY_USER_PROFILE_QUERY_KEY]),
	invalidate: (queryClient) => queryClient.invalidateQueries([{}, ...QUERY_USER_PROFILE_QUERY_KEY]),
	cancel: (queryClient) => queryClient.cancelQueries([{}, ...QUERY_USER_PROFILE_QUERY_KEY]),
	reset: (queryClient) => queryClient.resetQueries([{}, ...QUERY_USER_PROFILE_QUERY_KEY]),
} as const satisfies UseFullQueryOptions<UserProfile, Error> & QueryCacheInteractions<UserProfile>;

export const mutateUserProfile = {
	mutationKey: ["user", "profile"],
	mutationFn: (profile) => saveCurrentUserProfileFn({ body: profile }),
} as const satisfies UseMutationOptions<UserProfile, Error, UserProfile>;
